import { useTranslation } from 'react-i18next';
import { Button, Drawer } from '@/components';

import { BessFormNew } from './bess-form-new';
import { BESSProjectTechnology, ProjectTechnology, TechnologyCollection } from '@/features/projects/types';

export type BessDrawerProps = {
  readonly formId: string;
  readonly technology: ProjectTechnology;
  readonly isOpen: boolean;
  readonly onSubmit: (collection: TechnologyCollection, item: BESSProjectTechnology, description?: string) => void;
  readonly onClose: () => void;
};

export function BessDrawer({ formId, technology, isOpen, onSubmit, onClose }: BessDrawerProps) {
  const { t } = useTranslation(['projects']);
  const footer = (
    <>
      <Button size="lg" color="neutral" onClick={onClose}>
        {t('Cancel')}
      </Button>
      <Button type="submit" form={formId} size="lg" color="primary">
        {t('Save')}
      </Button>
    </>
  );

  return (
    <Drawer title={t('Bess Details & Design')} open={isOpen} onClose={onClose} footer={footer}>
      <BessFormNew
        id={formId}
        item={technology?.item as BESSProjectTechnology}
        onSubmit={(data: any) =>
          onSubmit('projects_bess_technologies', { ...technology?.item, ...data }, t('Bess Details has been updated'))
        }
      />
    </Drawer>
  );
}
